import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StudentSituationType } from "../../../types/StudentSituation";

const initialState: StudentSituationType = {
    id: "",
    description: "",
    status: true,
    isResolved: false,
    idStudent: "",
    studentCode: ""
};

export const studentSituationSlice = createSlice({
    name: "studentSituationForm",
    initialState,
    reducers: {
        setStudentSituationData: (state, action: PayloadAction<StudentSituationType>) => {
            return { ...state, ...action.payload };
        },
        resetStudentSituationData: () => initialState,
    }
});

export const { setStudentSituationData, resetStudentSituationData } = studentSituationSlice.actions;
export default studentSituationSlice.reducer;
